import { Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import AboutMePage from "./Pages/AboutMePage";
import LoginPage from "./Pages/LoginPage";
import ForgetPage from "./Pages/ForgetPage";
import RegisterPage from "./Pages/RegisterPage";
import ProfilePage from "./Pages/ProfilePage";
import YouSelfPage from "./Pages/YourSelfPage";
import YourPartnerPage from "./Pages/YourPartnerPage";
import YourChildPage from "./Pages/YourChildPage";
import YourPetPage from "./Pages/YourPetPage";
import YourFamilyPage from "./Pages/YourFamilyPage";
import DashboardPage from "./Pages/DashboardPage";
import DocumentPage from "./Pages/DocumentPage";
import YourFamilyReviewPage from "./Pages/YourFamilyReviewPage";
import ExecutorPage from "./Pages/ExecutorPage";
import AssetsPage from "./Pages/Assetspage";
import DividingEstatePage from "./Pages/DividingEstatePage";
import "react-responsive-modal/styles.css";
import EsatetPage from "./Pages/EstatePage";
import CharityPage from "./Pages/CharityPage";
import SplitEstatePage from "./Pages/SplitPage";
import PartnerDies from "./Pages/PartnerDies";
import PaymentPage from "./Pages/PaymentPage";
import Subscription from "./Pages/Subscription";
import UnlimitedUpdated from "./Pages/UnlimitedUpdated";
import Purchase from "./Pages/Purchase";
import GuardianReviewPage from "./Pages/GuardianReviewPage";
import GuardianAddReviewPage from "./Pages/GuardianAddReviewPage";
import GuardianReviewList from "./Pages/GuardinReviewList";
import ResetPasswordPage from "./Components/ResetPasswordPage";
import Executor from "./Components/Executor";
import ExecutorIntro1 from "./Components/IntroExecutor/ExecutorIntro1";
import ExecutorIntro2 from "./Components/IntroExecutor/ExecutorIntro2";
import AboutAsset from "./Components/AssetsComp/AboutAsset";
import ListGift from "./Pages/GiftPage/ListGift";
import Unlimited from "./Components/Unlimited";
import { useContext, useEffect, useState } from "react";
import { GetDahsboard, OrderHistoryData } from "./api/get";
import { AuthProvider, AuthContext, useAuth } from "./AuthContext";
import PurchaseComp from "./Components/PurchaseComp";
import PaymentSuccess from "./Components/Payment/PaymentSuccess";
import Invitation from "./Components/Invite/Invitation";
import OrderHistory from "./Components/Order/OrderHistory";
import OrderDetails from "./Components/Order/OrderDetails";
import Offers from "./Components/Offer/Offers";
import WillError from "./Components/Error/WillError";
function App() {
  const isAuthenticated = () => {
    if (JSON.parse(localStorage.getItem("willguru-token"))) {
      return true;
    } else {
      return false;
    }
    // Change this to true to simulate a logged-in user
  };
  const { paymentStatus, willCompleted, willStatus } = useAuth();
  const PrivateRoute = ({ element: Element, ...rest }) => {
    return isAuthenticated() &&
      (willStatus === "in_process" || willStatus === "in_updating") ? (
      <Element {...rest} />
    ) : (
      <Navigate to="/dashboard " />
    );
  };
  const PaymentRoute = ({ element: Element, ...rest }) => {
    return isAuthenticated() &&
      paymentStatus === "unpaid" &&
      willCompleted &&
      (willStatus === "in_process" || willStatus === "in_updating") ? (
      <Element {...rest} />
    ) : (
      <Navigate to="/dashboard" />
    );
  };
  const PublicRoute = ({ element: Element, ...rest }) => {
    return <Element {...rest} />;
  };
  const AuthRoute = ({ element: Element, ...rest }) => {
    return isAuthenticated() ? <Element {...rest} /> : <Navigate to="/" />;
  };
  return (
    <>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<PublicRoute element={LoginPage} />} />
        <Route
          path="/signup"
          element={<PublicRoute element={RegisterPage} />}
        />
        <Route
          path="/account-recovery"
          element={<PublicRoute element={ForgetPage} />}
        />
        <Route
          path="/onboarding"
          element={<PublicRoute element={AboutMePage} />}
        />
        <Route
          path="/reset-password/:token"
          element={<PublicRoute element={ResetPasswordPage} />}
        />

        {/* Authenticated Routes */}
        <Route path="/profile" element={<AuthRoute element={ProfilePage} />} />
        <Route
          path="/document"
          element={<AuthRoute element={DocumentPage} />}
        />
        <Route
          path="/dashboard"
          element={<AuthRoute element={DashboardPage} />}
        />
        <Route path="/invite" element={<AuthRoute element={Invitation} />} />
        <Route path="/offer" element={<AuthRoute element={Offers} />} />
        <Route path="/make-will-online/execution/errors" element={<AuthRoute element={WillError} />} />
        <Route
          path="/order-history"
          element={<AuthRoute element={OrderHistory} />}
        />
        <Route
          path="/order-details/:order_id"
          element={<AuthRoute element={OrderDetails} />}
        />
        {/* Protected Routes */}
        <Route
          path="/make-will-online/about-yourself/edit-personal-details"
          element={<PrivateRoute element={YouSelfPage} />}
        />
        <Route
          path="/make-will-online/about-yourself/partner"
          element={<PrivateRoute element={YourPartnerPage} />}
        />
        <Route
          path="/make-will-online/about-yourself/children"
          element={<PrivateRoute element={YourChildPage} />}
        />

        <Route
          path="/make-will-online/about-yourself/pets"
          element={<PrivateRoute element={YourPetPage} />}
        />
        <Route
          path="/make-will-online/about-yourself/review"
          element={<PrivateRoute element={YourFamilyReviewPage} />}
        />
        <Route
          path="/make-will-online/assets"
          element={<PrivateRoute element={AboutAsset} />}
        />

        <Route
          path="/make-will-online/assets/select"
          element={<PrivateRoute element={AssetsPage} />}
        />
        <Route
          path="/make-will-online/estate"
          element={<PrivateRoute element={DividingEstatePage} />}
        />
        <Route
          path="/make-will-online/estate/beneficiaries"
          element={<PrivateRoute element={EsatetPage} />}
        />
        <Route
          path="/make-will-online/estate/charity/standard"
          element={<PrivateRoute element={CharityPage} />}
        />
        <Route
          path="/make-will-online/estate/divide"
          element={<PrivateRoute element={SplitEstatePage} />}
        />
        <Route
          path="/make-will-online/estate/inheritance/:estate_beneficiary_id"
          element={<PrivateRoute element={PartnerDies} />}
        />
        <Route
          path="/make-will-online/estate/gifts"
          element={<PrivateRoute element={ListGift} />}
        />
        <Route
          path="/make-will-online/subscription/almost-ready"
          element={<PaymentRoute element={PaymentPage} />}
        />
        <Route
          path="/make-will-online/subscription/couples"
          element={<PaymentRoute element={Subscription} />}
        />
        <Route
          path="/make-will-online/subscription/options"
          element={<PaymentRoute element={Unlimited} />}
        />
        <Route
          path="/make-will-online/subscription/payment-couple"
          element={<PaymentRoute element={PurchaseComp} />}
        />
        <Route
          path="/make-will-online/payment/success"
          element={<PublicRoute element={PaymentSuccess} />}
        />
        <Route
          path="/make-will-online/guardians"
          element={<PrivateRoute element={GuardianReviewPage} />}
        />
        <Route
          path="/guardian/review/list/:id/:type"
          element={<PrivateRoute element={GuardianReviewList} />}
        />

        {/* Executor */}
        <Route
          path="/make-will-online/executors/intro-1"
          element={<PrivateRoute element={ExecutorIntro1} />}
        />
        <Route
          path="/make-will-online/executors/intro-2"
          element={<PrivateRoute element={ExecutorIntro2} />}
        />
        <Route
          path="/make-will-online/executors/select"
          element={<PrivateRoute element={ExecutorPage} />}
        />
      </Routes>
    </>
  );
}

export default App;
